import { useMutation } from '@tanstack/react-query';
import { getAudioPreview } from '../../services';

export function useGetAudioPreview() {
  return useMutation(getAudioPreview, { onSuccess: (data) => data });
}
